/**
 * DATA LAYER: BONGO CAM OVERLAY
 * Se encarga de la comunicación HTTP con la API de Bongo Cam.
 */

export const GetBongoConfig = async () => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}bongo/config`);
        if (!response.ok) return { success: false };
        const data = await response.json();
        return { success: true, data };
    } catch (error) {
        return { success: false, message: 'Error de conexión.' };
    }
};

export const SetBongoConfig = async (config) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}bongo/config`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(config)
        });
        if (!response.ok) return { success: false };
        const data = await response.json();
        return { success: true, data };
    } catch (error) {
        return { success: false, message: 'Error de conexión.' };
    }
};

export const ShowBongoOverlay = async () => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}bongo/show`, { method: 'POST' });
        return { success: response.ok };
    } catch (error) {
        return { success: false, message: 'Error de conexión.' };
    }
};

export const HideBongoOverlay = async () => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}bongo/hide`, { method: 'POST' });
        return { success: response.ok };
    } catch (error) {
        return { success: false, message: 'Error de conexión.' };
    }
};

export const TriggerBongoHit = async (side) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}bongo/hit?side=${side}`, { method: 'POST' });
        return { success: response.ok };
    } catch (error) {
        return { success: false, message: 'Error de conexión.' };
    }
};

export const TriggerBongoMode = async (level) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}bongo/mode?level=${level}`, { method: 'POST' });
        return { success: response.ok };
    } catch (error) {
        return { success: false, message: 'Error de conexión.' };
    }
};
